import DatosTransferenciaComponente from "@/erp/inventario/componente/datos-transferencia-componente";
import {
  EstadoTransitoInventarioENUM,
  gridSize,
  gridSize0,
  gridSizeMdLg12,
  gridSizeMdLg6,
  mapSeriesToSeriesMetros,
  ROUTER_PATHS,
  useUploadFile,
} from "@/shared";
import { useFetchCreateTransferenciaInventario } from "@/shared/actions/erp";
import {
  transitoInventarioArchivoRecepcion,
  useFetchPutTransitoInventario,
} from "@/shared/actions/erp/transito_inventaro.actions";
import {
  ButtonFileComponente,
  LoaderComponent,
  SingleTableBoxScene,
  TabTextLabel,
} from "@/shared/components/ui";
import ModalProductoSeries from "@/shared/components/ui/CargarSeries/ModalProductoSeries";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import { useTableColumnsInventarioSerie } from "@/shared/hooks/useTableColumnsInventarioSerie";
// import { MaterialTransferido } from "@/shared/interfaces";
import { ITransitoInventario } from "@/shared/interfaces/erp/administration/transito_inventario.interface";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { useUiStore } from "@/store/ui";
import {
  CancelPresentation,
  Checklist,
  CloudDownload,
} from "@mui/icons-material";
import { Button, Grid, Paper } from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  RECEPCION_DOCUMENTO_ACCEPT,
  validateRecepcionDocumentoFile,
} from "../recepcion_documento_upload";

interface SaveRevisionTransferenciaInventarioProps {
  dataTransferenciaInventario: ITransitoInventario;
  title: string;
}

export default function SaveRecepcionTransferenciaInventario({
  dataTransferenciaInventario,
  title,
}: SaveRevisionTransferenciaInventarioProps) {
  const navigate = useNavigate();

  ///* store
  const handleCopiarLista = useCargarSeriesProductos(
    (s) => s.handleCopiarLista,
  );
  const productos = useCargarSeriesProductos((s) => s.productos);
  const paginatedData = useCargarSeriesProductos((s) => s.paginatedData);
  const setPagination = useCargarSeriesProductos((s) => s.setPagination);
  const pagination = useCargarSeriesProductos((s) => s.pagination);
  const clearSelectedItems = useCargarSeriesProductos(
    (s) => s.clearSelectedItems,
  );
  const handleAgregarUrlSerieParams = useCargarSeriesProductos(
    (s) => s.handleAgregarUrlSerieParams,
  );

  const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);
  const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);

  const { columnsRecepcionTransferenciaInventario } =
    useTableColumnsInventarioSerie();

  const { handleUploadFile } = useUploadFile();

  ///* react query

  const {
    mutateAsync: mutateAsyncTransferenciaProducto,
    isPending: isPendingTraslado,
  } = useFetchCreateTransferenciaInventario();

  const { mutateAsync: mutateAsyncPutTransitoInventario } =
    useFetchPutTransitoInventario({
      navigate,
      returnUrl: `${ROUTER_PATHS.inventario.recepcionTransferenciaInventarioNav}`,
    });

  //FORM
  const form = useForm<any, any, any>({});

  const {
    reset,
    control,
    formState: { errors },
  } = form;

  useEffect(() => {
    if (!dataTransferenciaInventario) return;

    const newData = dataTransferenciaInventario.productos.map((element) => {
      return {
        ...element,
        ubicacion_origen: dataTransferenciaInventario.ubicacion_transito,
        cantidad_acumulada_temp: element.cantidad_acumulada,
        series: [],
      };
    });

    handleCopiarLista(newData ?? []);

    return () => {
      clearSelectedItems();
    };
  }, [dataTransferenciaInventario]);

  const [urlDocumentoRecibido, setUrlDocumentoRecibido] = useState("");
  const handleUploadDocumento = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files?.[0];

    if (!file) return;

    const validationMessage = await validateRecepcionDocumentoFile(file);
    if (validationMessage) {
      toast.error(validationMessage);
      return;
    }

    const formData = new FormData();

    formData.append("archivo", file);
    formData.append("id", dataTransferenciaInventario.id_transito_inventario);

    try {
      const data = (await transitoInventarioArchivoRecepcion(formData)) as any;
      setUrlDocumentoRecibido(data?.url);
      toast.success(data.message || "Archivo cargado");
    } catch (error) {
      console.error(error);
      toast.error("Ocurrio un error al subir el archivo");
    }
  };

  const onSubmitRecepcionTotal = () => {
    setConfirmDialogIsOpen(true);

    let mensajeDocumentoAlternativo = "";
    if (urlDocumentoRecibido === "") {
      mensajeDocumentoAlternativo = "sin el documento de recepción firmado,";
    }

    setConfirmDialog({
      isOpen: true,
      title: `Cambiar Estado ${mensajeDocumentoAlternativo}`,
      subtitle: `Está a punto de cerrar una recepción de traslado, ${mensajeDocumentoAlternativo} lo que generará un movimiento de inventario. Una vez realizado, el cambio será irreversible. ¿Estás seguro de que deseas continuar?`,
      onClose() {
        setConfirmDialogIsOpen(false);
      },
      onConfirm: async () => {
        try {
          setConfirmDialogIsOpen(false);

          // if (urlDocumentoRecibido === '') {
          //   toast.error('Debe subir el documento de recepción firmada');
          //   return false;
          // }

          const existeError = productos.some((item) => {
            const cantidadOk =
              Number(item.cantidad_recibida || 0) ===
              Number(item.cantidad_esperada || 0);
            return !cantidadOk;
          });

          if (existeError) {
            toast.error(
              "Existen productos con cantidades pendientes de recibir",
            );
            return false;
          }

          const arrayProducto = productos
            .filter(
              (item) =>
                item.cantidad_recibida != null &&
                Number(item.cantidad_recibida) > 0,
            )
            .map((e) => ({
              ...e,
              cantidad: e.cantidad_recibida ?? "0",
              cantidad_metros: e.cantidad_metros ?? "0",
            }));

          console.log("arrayProducto", arrayProducto);

          ///* finalizar la recepcion de traslado
          if (arrayProducto.length == 0) {
            let estadoFinalTransito = EstadoTransitoInventarioENUM.ENTREGADO;
            if (urlDocumentoRecibido === "") {
              estadoFinalTransito =
                EstadoTransitoInventarioENUM.PENDIENTE_DOCUMENTO;
            }
            await mutateAsyncPutTransitoInventario({
              id: dataTransferenciaInventario.id_transito_inventario,
              data: {
                estado_transito: estadoFinalTransito,
              },
            });

            return;
          }

          ///* generar movimiento

          for (let element of arrayProducto) {
            const { series, contiene_serie, cantidad_recibida } = element;

            if (series && series?.length != Number(cantidad_recibida ?? 0)) {
              if (contiene_serie) {
                return toast.info(
                  `El producto con el código ${element.producto_data?.codigo} tiene una discrepancia entre la cantidad ingresada y las series cargadas. Por favor, revisa la información y vuelve a intentarlo.`,
                );
              }
            }
          }

          const nuevoSeriesData =
            (await handleAgregarUrlSerieParams(
              handleUploadFile,
              arrayProducto,
            )) ?? [];
          const temp = mapSeriesToSeriesMetros(nuevoSeriesData);

          const {
            bodega_transito,
            ubicacion_transito,
            bodega_destino,
            ubicacion_destino,
          } = dataTransferenciaInventario;

          const sendData = {
            bodega_origen: bodega_transito,
            ubicacion_origen: ubicacion_transito,
            bodega_destino: bodega_destino,
            ubicacion_destino: ubicacion_destino,
            productos: temp,
            fecha_actual_fronted: dayjs().toISOString(),
            observaciones: {
              observaciones_1: form.getValues().observacion_1,
            },
          };

          // traslado inventario
          const resp = await mutateAsyncTransferenciaProducto(sendData);

          if (resp.code == 200) {
            let estadoFinalTransito = EstadoTransitoInventarioENUM.ENTREGADO;
            if (urlDocumentoRecibido === "") {
              estadoFinalTransito =
                EstadoTransitoInventarioENUM.PENDIENTE_DOCUMENTO;
            }
            ///* transito inventario
            mutateAsyncPutTransitoInventario({
              id: dataTransferenciaInventario.id_transito_inventario,
              data: {
                traslado_final: resp.data.codigo,
                estado_transito: estadoFinalTransito,
              },
            });
          }
        } catch (error) {
          toast.error(`Lo sentimos ocurrio en error [${error}]`);
        }
      },
    });
  };

  const onSubmitRechazadoTotal = (data: any) => {
    setConfirmDialogIsOpen(true);

    setConfirmDialog({
      isOpen: true,
      title: "Cambiar Estado a Rechazado",
      subtitle:
        "Estás a punto de RECHAZAR una recepción de traslado en su totalidad, lo que generará un movimiento de inventario y la DEVOLUCIÓN a su ubicacion de origen. Una vez realizado, el cambio será irreversible. ¿Estás seguro de que deseas continuar?",
      onClose() {
        setConfirmDialogIsOpen(false);
      },
      onConfirm: async () => {
        setConfirmDialogIsOpen(false);

        try {
          // salen de transito a su origen
          let codigo_bodega_origen = data?.bodega_transito_data?.codigo;
          let codigo_ubicacion_origen = data?.ubicacion_transito_data?.codigo;
          // regresan a transito para seguir el proceso
          let codigo_bodega_destino = data?.bodega_origen_data?.codigo;
          let codigo_ubicacion_destino = data?.ubicacion_origen_data?.codigo;

          if (codigo_bodega_origen == "") {
            toast("Bodega de origen no existe");
            return;
          }

          if (codigo_ubicacion_origen == "") {
            toast("Ubicacion de origen no existe");
            return;
          }

          const productosEnviar = [] as any;
          data.productos.forEach((item: any) => {
            if (item.usa_metros && item.contiene_serie) {
              productosEnviar.push({
                codigo: item.codigo,
                cantidad: item.series?.length + "" || "0",
                series: item.series,
                cantidad_metros: item.cantidad_metros,
                series_metros: item.series_metros,
              });
            } else if (!item.usa_metros && item.contiene_serie) {
              productosEnviar.push({
                codigo: item.codigo,
                cantidad: item.series?.length + "" || "0",
                series: item.series,
              });
            } else {
              productosEnviar.push({
                codigo: item.codigo,
                cantidad: item.cantidad_esperada + "",
                series: [],
              });
            }
          });

          const payloadEquipment: any = {
            bodega_origen: codigo_bodega_origen,
            ubicacion_origen: codigo_ubicacion_origen,
            bodega_destino: codigo_bodega_destino,
            ubicacion_destino: codigo_ubicacion_destino,
            productos: productosEnviar,
          };

          await mutateAsyncTransferenciaProducto(payloadEquipment, {
            onSuccess: async () => {
              toast.success("Transito Rechazado");
              // cambiar de estado el transito
              await mutateAsyncPutTransitoInventario({
                id: data?.id_transito_inventario!,
                data: {
                  estado_transito: EstadoTransitoInventarioENUM.RECHAZADO,
                },
              });
              // window.location.reload()
            },
            onError: () => {
              toast.error(
                "Error al retornar el equipamiento a la ubicacion de origen",
              );
            },
          });
        } catch (err: any) {
          toast.error(err.message || "Ocurrio un error");
        }
      },
    });
  };

  const { descargarPdfDesdeurl } = useUploadFile();

  const handleDescargarPdf = async () => {
    const trasladoIncial = dataTransferenciaInventario.traslado_inicial_data;

    if (trasladoIncial == null) {
      toast.info("No exsiste un traslado incial");
      return;
    }

    const { numero_referencia, url_pdf } = trasladoIncial;

    let url = url_pdf;
    const fileName = `${numero_referencia}_${dayjs().format("YYYY-MM-DD")}`;

    if (!url) {
      toast.info("No se encuentra el documento");
      return;
    }

    // Si llegamos aquí, siempre hay una URL
    descargarPdfDesdeurl(url, fileName);
  };

  if (isPendingTraslado) return <LoaderComponent />;

  return (
    <>
      <SingleTableBoxScene
        title={title}
        visibleReport={false}
        enableBackBtn={true}
        backPageUrl={
          ROUTER_PATHS.inventario.recepcionTransferenciaInventarioNav
        }
        gridSizeBtnAccion={gridSizeMdLg12}
        gridSizeTitle={gridSize0}
        //showRechazarBtn={true}
      >
        <Grid container spacing={3}>
          <DatosTransferenciaComponente
            control={control}
            errors={errors}
            form={form}
            reset={reset}
            dataTransferenciaInventario={dataTransferenciaInventario as any}
            onChangeDeleteItem={() => {
              //clearSelectedItems(MaterialesKey.selectItemsProductoTransferencia);
            }}
          />

          <Grid container spacing={3} item justifyContent={"end"}>
            <Grid item>
              {urlDocumentoRecibido === "" ? (
                <ButtonFileComponente
                  titulo={"Documento Recepción Firmada"}
                  accept={RECEPCION_DOCUMENTO_ACCEPT}
                  onChange={(e) => handleUploadDocumento(e)}
                />
              ) : (
                "Documento ya cargado"
              )}
            </Grid>

            <Grid item>
              <Button
                variant="outlined"
                startIcon={<CloudDownload />}
                onClick={() => {
                  handleDescargarPdf();
                }}
              >
                Descargar Reporte
              </Button>
            </Grid>

            {/* <Grid item>
              <Button
                startIcon={<LowPriority />}
                variant="outlined"
                color="primary"
                onClick={() => {
                  onSubmitRecepcionParcial()
                }}
              >
                Recepción Parcial
              </Button>
            </Grid> */}
            <Grid item>
              <Button
                startIcon={<CancelPresentation />}
                variant="outlined"
                color="error"
                onClick={() => {
                  onSubmitRechazadoTotal(dataTransferenciaInventario);
                }}
              >
                Rechazado
              </Button>
            </Grid>

            <Grid item>
              <Button
                startIcon={<Checklist />}
                variant="outlined"
                color="success"
                onClick={() => {
                  onSubmitRecepcionTotal();
                }}
              >
                Completado
              </Button>
            </Grid>
          </Grid>

          <Grid item {...gridSize}>
            <Paper className="paper-producto">
              <Grid
                container
                spacing={1}
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <Grid item>
                  <TabTextLabel
                    text={"Items Seleccionado"}
                    mt={0}
                    pb={0}
                    pl={0}
                    pt={0}
                  />
                </Grid>
                <div className="linea"></div>
                <Grid item xs={12}>
                  <SampleTablePagination
                    columns={columnsRecepcionTransferenciaInventario}
                    data={paginatedData}
                    rowCount={productos.length}
                    setPagination={setPagination}
                    pagination={pagination}
                    rowNumber={true}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </SingleTableBoxScene>

      <ModalProductoSeries
        generarSerie={false}
        seleccionarAutomatico={false}
        seleccionarManual={false}
        size={gridSizeMdLg6}
        enableActionManual={false}
      />

      {/* <ModalInventariableProductoFactor
        generarSerie={false}
        seleccionarAutomatico={false}
        seleccionarManual={false}
        size={gridSizeMdLg6}
      /> */}
    </>
  );
}
